import RecordBooksChildren from "@/router/atmo/projects/project/recordbooks/recordBookLists/children";

const RecordBookDetail = () =>
  import(
    /* webpackChunkName: "RecordBook" */ "@/components/atmo/projects/project/recordbooks/RecordBookDetail.vue"
  );
const RecordBooks = () =>
  import(
    /* webpackChunkName: "RecordBook" */ "@/components/atmo/projects/project/recordbooks/RecordBooks.vue"
  );

export default [
  {
    path: "",
    component: RecordBooks,
    children: RecordBooksChildren,
    meta: {
      subNavs: "recordBooks",
    },
  },
  {
    path: ":recordBookUuid",
    name: "record-book-detail",
    component: RecordBookDetail,
  },
];
